module.exports = __webpack_public_path__ + "img/hero-background-m.4a36a5c8.jpg";